<template>
<h1 class="text-center">PhysicsPropsPlugin</h1>
</template>

<script>
export default {
  name: "PhysicsPropsPlugin"
}
</script>

<style scoped>

</style>